export default __webpack_public_path__ + "src/images/packages/maliba-lodge/6061bac6b77b52a77a26e5999db74516-4.jpeg";